module.exports = {"id":"164852","name":"Bruno Gama","rating":"74","photo":"./data/images/photos/0/164852.png","club":{"name":"AD Alcorcón","logo":"./data/images/clubs/ADAlcorcon.png"},"positions":["MD","MOC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrunoGama0.json
// module id = 659
// module chunks = 0